require('../../../modules/es.string.sup');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').sup;
